import React, { useState, useContext } from "react";
import "./reportReviewModal.css";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import usersRequest from "../../request/usersRequest";
import useModalDismiss from "../common/useModalDismiss";

const ReportReviewModalAdmin = ({ open, onClose, reviewId, shopId }) => {
	useModalDismiss(onClose, { enabled: open });
	const { language, userData } = useContext(CombinedContext);

	const [details, setDetails] = useState("");
	const [loading, setLoading] = useState(false);
	const [toast, setToast] = useState("");

	if (!open) return null;

	const t = translations[language].reportReview;

	async function submitReport() {
		try {
			setLoading(true);

			await usersRequest.flagReview(shopId, reviewId, {
				reason: "Reported by shop/admin",
				message: details,
				email: userData?.user?.email || null,
			});

			setToast(t.actions.success);

			setTimeout(() => {
				onClose();
			}, 800);
		} catch (err) {
			console.error("Failed to report review:", err);
			setToast(t.actions.error);
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="sf-report-overlay">
			<div className="sf-report-modal">
				<div className="sf-report-header">
					<h3 className="sf-report-title">{t.title}</h3>
					<button className="sf-report-close" onClick={onClose}>✕</button>
				</div>

				<div className="sf-report-body">
					<p className="sf-report-subtitle">{t.adminSubtitle}</p>

					<textarea
						className="sf-report-textarea"
						placeholder={t.adminPlaceholder}
						value={details}
						onChange={(e) => setDetails(e.target.value)}
					/>
				</div>

				<div className="sf-report-footer">
					<button className="sf-report-btn-cancel" onClick={onClose}>
						{t.actions.cancel}
					</button>
					<button className="sf-report-btn-submit" onClick={submitReport} disabled={loading}>
						{loading ? t.actions.submitting : t.actions.submit}
					</button>
				</div>

				{toast && <div className="sf-report-toast">{toast}</div>}
			</div>
		</div>
	);
};

export default ReportReviewModalAdmin;